<template>
  <v-dialog v-model="dialog" persistent width="800">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
       
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{
            form.id ? "Editar Experiencia de Trabajo" : "Crear Experiencia de Trabajo"
          }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md126>
                <v-text-field
                  label="Institución"
                  v-model="form.institucion"
                  :rules="$validate(['required'])"
                  maxlength="250"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-autocomplete
                  v-model="form.id_pais"
                  :items="paises"
                  item-text="pais"
                  :item-value="val => parseInt(val.id)"
                  label="País"
                  :rules="$validate(['required'])"
                ></v-autocomplete>
              </v-flex>

              <v-flex md12>
                <v-text-field
                  label="Puesto"
                  v-model="form.puesto"
                  :rules="$validate(['required'])"
                  maxlength="250"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex md3>
                <v-text-field
                  type="date"
                  label="Fecha de inicio"
                  v-model="form.fecha_inicio"
                  :rules="$validate(['required'])"
                  required
                  
                ></v-text-field>
              </v-flex>
              <v-flex md3>
                <v-text-field
                  type="date"
                  label="Fecha de conclusión"
                  v-model="form.fecha_conclusion"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex md3>
                <p>Tiempo</p>
                <v-text-group
                  v-model="form.id_parametro_tipo_empresa"
                  row
                  :rules="$validate(['required'])"
                  required
                >
                  <v-text-field label="Años" :value="anio"></v-text-field>
                  <v-text-field label="Meses" :value="mes"></v-text-field>
                  <v-text-field label="Dias" :value="dia"></v-text-field>
                </v-text-group>
              </v-flex> -->
              <v-flex md4>
                <p>Tipo Empresa</p>
                <v-radio-group
                  v-model="form.id_parametro_tipo_empresa"
                  row
                  :rules="$validate(['required'])"
                  required
                >
                  <v-radio label="Pública" :value="1"></v-radio>
                  <v-radio label="Privada" :value="2"></v-radio>
                </v-radio-group>
              </v-flex>

              <v-flex md6>
                <!-- {{$data.form}} -->
                <p>Personal Dependiente</p>
                <v-radio-group v-model="form.personal_dependiente" row>
                  <v-radio label="Sí" :value="2"></v-radio>
                  <v-radio label="No" :value="3"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  type="number"
                  label="Nro de personas dependientes"
                  v-model="form.nro_personas_dependientes"
                  :disabled="form.personal_dependiente === 3"
                  :rules="[
                    v => {
                      
                      if (v < 0) {
                        return 'El número no tiene que ser negativo.';
                      }
                      
                      return true;
                    }
                  ]"
                ></v-text-field>
              </v-flex>

              <!-- <v-flex md6>
                <v-text-field
                  label="Nombre del jefe inmediato superior"
                  v-model="form.nombre_jefe"
                  maxlength="250"
                ></v-text-field>
              </v-flex> -->
              <!-- <v-flex md6>
                <v-text-field
                  label="Puesto del jefe inmediato superior"
                  v-model="form.puesto_jefe"
                  maxlength="250"
                ></v-text-field>
              </v-flex> -->
              <v-flex md12>
               
                <v-textarea
                  label="Funciones principales"
                  v-model="form.funciones_principales"
                  :rules="$validate(['required'])"
                  required
                  maxlength="1200"
                ></v-textarea>
              </v-flex>
              <v-flex md12>
                <v-select
                  :items="motivo_finalizacion"
                  item-text="valor"
                  :item-value="x=>parseInt(x.id)"
                  label="Motivo de finalización del vínculo laboral o continuidad en el cargo"
                  v-model="form.id_parametro_motivo_finalizacion"
                  :rules="$validate(['required'])"
                ></v-select>
              </v-flex>
              <v-flex md12>
                <v-text-field
                  label="Explicar brevemente el motivo de la  finalización del vínculo laboral"
                  v-model="form.resumen_motivo"
                  maxlength="250"
                ></v-text-field>
              </v-flex>
              <v-flex md12>
                  
                
                <input
                  id="input"
                  type="file"
                  @change="handleFileUpload()"
                  ref="file"
                  accept="image/*, application/pdf"
                  :rules="$validate(['required'])"
                  required
                />
                <p class="red--text body-1" v-if="error">
                  {{ mensjageerror }}
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import axios from "axios";


export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      info: null,
      paises: [],
      pais: [],
      anio:[],
      mes:[],
      dia:[],
      nro_personas_dependientes: {},
      motivo_finalizacion: [],
      personal_dependiente:[],
      file: "",
      documento_requisito: {},
      error: false,
      cargado: false,
      mensjageerror: "",
      
      
    };
  },
  mounted() {
    //this.apiPaises();
    this.obtenerPaises();
    this.cargarParametros();
    //this.calcularEdad();
    //this.validate_fecha();
    this.$bus.$on("openDialogCrearActualizarExperienciaTrabajo", (item) => {
         
            //console.log(item );  
            if (item.personal_dependiente === true) {
              //console.log('MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM');
              item.personal_dependiente = 2;
            }else{
              item.personal_dependiente = 3;
              //console.log('UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU');
              //console.log(this.form); 
            } 
            // let fecha1= this.$moment(this.form.fecha_conclusion,'DD/MM/YYYY')
            // let fecha2= this.$moment(this.form.fecha_inicio,'DD/MM/YYYY') 
            // const fecha_temp = fecha2.diff(fecha1,'YYYY')    
            // console-log(fecha_temp)          
      
        this.form = item;
             
      this.dialog = true;
    });
  },
  methods: {
    // async apiPaises() {
    //   let respuesta = await axios.get(
    //     "https://restcountries.eu/rest/v2/lang/es"
    //   );
    //   this.info = respuesta.data;
    //   this.info.forEach((item) => {
    //     item.name;
    //   });
      
    // },
    async obtenerPaises() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            paisess{
              rows{
                id
                codigo
                pais
              }
            }
          }
        `,
      });
      
      this.paises = respuesta.paisess.rows;
      
    },
    // async calcularAnio(fecha_inicio,fecha_conclusion) {
    // // let fecha1 = new Date(fecha_conclusion);
    // // let fecha2 = new Date(fecha_inicio);
    // // let anio = fecha1.getFullYear() - fecha2.getFullYear();
    // // console.log(fecha1+'*******'+fecha2)
    // // let m = fecha1.getMonth() - fecha2.getMonth();

    // // if (m < 0 || (m === 0 && fecha1.getDate() < fecha2.getDate())) {
    // //     anio--;
    // // }
    // var fecha1 = $moment('2000-08-12');
    // var fecha2 = $moment('2019-09-01');

    //  console.log(fecha2.diff(fecha1, 'years'), ' años de diferencia');

    // console.log('Añooooo::'+anio);
    // console.log('Mnnnmmmmm::'+m);
    // return this.anio;
    // }

    isValidDate(day,month,year){

    var dteDate;

 
    // En javascript, el mes empieza en la posicion 0 y termina en la 11 
    //   siendo 0 el mes de enero
    // Por esta razon, tenemos que restar 1 al mes

    month=month-1;

    // Establecemos un objeto Data con los valore recibidos
    // Los parametros son: año, mes, dia, hora, minuto y segundos
    // getDate(); devuelve el dia como un entero entre 1 y 31
    // getDay(); devuelve un num del 0 al 6 indicando siel dia es lunes,
    //   martes, miercoles ...
    // getHours(); Devuelve la hora
    // getMinutes(); Devuelve los minutos
    // getMonth(); devuelve el mes como un numero de 0 a 11
    // getTime(); Devuelve el tiempo transcurrido en milisegundos desde el 1
    //   de enero de 1970 hasta el momento definido en el objeto date
    // setTime(); Establece una fecha pasandole en milisegundos el valor de esta.
    // getYear(); devuelve el año
    // getFullYear(); devuelve el año

    dteDate=new Date(year,month,day);
    //Devuelva true o false...
    return ((day==dteDate.getDate()) && (month==dteDate.getMonth()) && (year==dteDate.getFullYear()));

    },

/**
 * Funcion para validar una fecha
 * Tiene que recibir:
 *  La fecha en formato ingles yyyy-mm-dd
 * Devuelve:
 *  true-Fecha correcta
 *  false-Fecha Incorrecta
 */

  // validate_fecha(fecha){

  //   var patron=new RegExp("^(19|20)+([0-9]{2})([-])([0-9]{1,2})([-])([0-9]{1,2})$");
  //   if(fecha.search(patron)==0)
  //   {
  //       var values=fecha.split("-");
  //       if(isValidDate(values[2],values[1],values[0]))
  //       {
  //           return true;

  //       }

  //   }

  //   return false;

  // },
 
/**

 * Esta función calcula la edad de una persona y los meses
 * La fecha la tiene que tener el formato yyyy-mm-dd que es
 * metodo que por defecto lo devuelve el <input type="date">
 */

  // calcularEdad(){

  //       var fecha='2019-08-12';
  //     if(validate_fecha(fecha)==true)

  //     {

  //       // Si la fecha es correcta, calculamos la edad
  //       var values=fecha.split("-");
  //       var dia = values[2];
  //       var mes = values[1];
  //       var ano = values[0];
  //       // cogemos los valores actuales
  //       var fecha_hoy = new Date();
  //       var ahora_ano = fecha_hoy.getYear();
  //       var ahora_mes = fecha_hoy.getMonth()+1;
  //       var ahora_dia = fecha_hoy.getDate();
  //       // realizamos el calculo
  //       var edad = (ahora_ano + 1900) - ano;
  //       if ( ahora_mes < mes )
  //       {

  //           edad--;

  //       }

  //       if ((mes == ahora_mes) && (ahora_dia < dia))
  //       {
  //           edad--;

  //       }
  //       if (edad > 1900)
  //       {
  //           edad -= 1900;
  //       }

  //       // calculamos los meses
  //       var meses=0;

  //       if(ahora_mes>mes)
  //           meses=ahora_mes-mes;
  //       if(ahora_mes<mes)
  //           meses=12-(mes-ahora_mes);
  //       if(ahora_mes==mes && dia>ahora_dia)
  //           meses=11;
  //       // calculamos los dias

  //       var dias=0;

  //       if(ahora_dia>dia)
  //           dias=ahora_dia-dia;
  //       if(ahora_dia<dia)
  //       {
  //           ultimoDiaMes=new Date(ahora_ano, ahora_mes, 0);
  //           dias=ultimoDiaMes.getDate()-(dia-ahora_dia);
  //       }

  //       console.log("Tienes "+edad+" años, "+meses+" meses y "+dias+" días");

  //     }else{
  //       console.log("La fecha "+fecha+" es incorrecta");
  //         }

  //   },

    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        this.cargado = true;
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].size > 2048999) {
          this.error = true;
          this.mensjageerror = "El archivo excede el tamaño permitido de 2MB.";
        } 
        else if (this.$refs.file.value === "") {
          this.error = true;
          this.mensjageerror = "Archivo invalido.";
        } else if (!(
          this.$refs.file.files[0].type.includes("application/pdf") ||
          this.$refs.file.files[0].type.includes("image/"))) {
          this.error = true;
          this.mensjageerror = "Formato no admitido por el sistema";
        } 
        else {
          this.error = false;
          this.mensjageerror = "";
        }
        this.file = file;
      }
    },
    
    async cargarParametros() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                      query{
                  params(tipo:"motivo_desvinculacion"){
                    rows{
                      id
                      valor
                    }
                  }
                }					
             `,
        });
        this.motivo_finalizacion = respuesta.params.rows;
      } catch (error) {
        console.log(error);
      }
      //console.log(this.form);
    },
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.file = null;
      this.cargado= false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async save() {
      if (this.error) {
        return this.error;
      }
       
      if (this.$refs.form.validate()) {
        let user = this.$storage.get('user')
      }

      if (this.form.nro_personas_dependientes && this.form.personal_dependiente) {
        this.form.nro_personas_dependientes = parseInt(this.form.nro_personas_dependientes);
        
        delete this.form.parametro_motivo_finalizacion;
        
        
      }

      if (this.form.personal_dependiente == 2) {
          let a = true;
          this.form.personal_dependiente = a;
        } else if(this.form.personal_dependiente == 3){
          let b = false;
          this.form.personal_dependiente = b;
          this.form.nro_personas_dependientes=0
        }

      if (this.$refs.form.validate()) {
        this.loading = true;
        try {

            this.loading = true;
            if (this.cargado) {
            let formData = new FormData();
            formData.append("file", this.file);
            let res = await this.$http.post(
              process.env.API_URL + "public/upload",
              formData
            );
            this.form.url_documento = res.data;
            }
         
           this.form.id_pais=parseInt(this.form.id_pais) 
            
          if (this.form.id) {
            
            const id = this.form.id;
            delete this.form.id;
            delete this.form.parametro_motivo_finalizacion
            delete this.form._user_created;
            delete this.form._user_updated;
            delete this.form._created_at;
            delete this.form._updated_at;
            delete this.form.pais
            // if(this.form.personal_dependiente === 3) 
            // this.form.nro_personas_dependientes=0

            await this.$service.graphql({
              query: `
								mutation edit($id: ID!, $experiencia_trabajo: EditExperienciaTrabajo!){
									experienciaTrabajoEdit(id: $id, experiencia_trabajo: $experiencia_trabajo){
										id
									}
								}
							`,
              variables: {
                id: id,
                experiencia_trabajo: this.form,
              },
            });
          } else {
            if (!this.cargado) {
              this.error = true;
              this.mensjageerror = "Debe seleccionar un archivo.";
              this.loading = false;
              return false;
            } else {
              this.error = false;
              this.mensjageerror = "";
            }
            delete this.form.pais
            this.form.id_estado = 1;
            let user = this.$storage.get("user");
            if (this.$route.params.id) {
              this.form.id_persona = parseInt(this.$route.params.id)
            } else {
              this.form.id_persona = user.id_persona
            }
            // if(this.form.personal_dependiente === false) 
            // this.form.nro_personas_dependientes=0

            await this.$service.graphql({
              query: `
								mutation add($experiencia_trabajo: NewExperienciaTrabajo!){
									experienciaTrabajoAdd(experiencia_trabajo: $experiencia_trabajo){
										id
									}
								}
							`,
              variables: {
                experiencia_trabajo: this.form,
              },
            });
          }
        } catch (error) {
          console.log(error);
        }
         document.getElementById("input").value = "";
        this.$message.success();
        this.loading = false;
        this.close();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/dialogs/CrearActualizarExperienciaTrabajo.vue